import axiosInstance from './BaseService';
import  UserData  from '../models/UserData';

import { useSelector, useDispatch } from "react-redux";
// Create an Axios instance

//Function to create user by admin
async function createUserByAdmin(userData: UserData): Promise<UserData> {
  try {
    const response = await axiosInstance.post<UserData>('/users', userData);
    return response.data;
  } catch (error) {
    throw error;
  }
}

// Function to create a new user
async function createUser(userData: UserData): Promise<UserData> {
  try {
    const response = await axiosInstance.post<UserData>('/register', userData);
    return response.data;
  } catch (error) {
    throw error;
  }
}

// Function to get user by ID
async function getUserById(userId: number): Promise<UserData> {
  try {
    const response = await axiosInstance.get<UserData>(`/users/${userId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
}

// Function to get all users with pagination, search, and role filter
async function getAllUsers(page: number = 1, limit: number = 12, search: string = '', role: string = ''): Promise<{users: UserData[], totalUsers: number, hasMore: boolean, currentPage: number}> {
  try {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
      ...(search && { search }),
      ...(role && { role })
    });
    const response = await axiosInstance.get(`/users?${params}`);
    return response.data;
  } catch (error) {
    throw error;
  }
}

// Function to get loged in user from JWT
async function getLoggedInUser(): Promise<UserData> {
  try {
    const response = await axiosInstance.get<UserData>('/users/me');
    return response.data;
  } catch (error) {
    throw error;
  }
}

// Function to update user by ID
async function updateUser(userId: any, updatedUserData: UserData): Promise<UserData> {
  try {
    const response = await axiosInstance.put<UserData>(`/users/${userId}`, updatedUserData);
    return response.data;
  } catch (error) {
    throw error;
  }
}

// Function to update profile (limited fields)
async function updateProfile(profileData: Partial<UserData>): Promise<UserData> {
  try {
    const response = await axiosInstance.put<UserData>('/profile/me', profileData);
    return response.data;
  } catch (error) {
    throw error;
  }
}

// Function to delete user by ID
async function deleteUser(userId: string): Promise<void> {
  try {
    await axiosInstance.delete(`/users/${userId}`);
  } catch (error) {
    throw error;
  }
}

// Function to check if an email or username is already in use
async function checkExistingEmailOrUsername(email: string, username: string): Promise<boolean> {
  try {
    const response = await axiosInstance.get<boolean>(`/users/check?email=${email}&username=${username}`);
    return response.data;
  } catch (error) {
    throw error;
  }
}

//Login User
async function loginUser(userData: UserData): Promise<UserData> {
  try {
   if(!userData.username || userData.username === '') {
   userData.username = userData.email||"";}
    const response = await axiosInstance.post<UserData>('/login', userData);
    return response.data;
  } catch (error) {
    throw error;
  }
}
// Function to initiate the "forgot password" process
async function forgotPassword(email: string): Promise<void> {
  try {
    let response =  await axiosInstance.post<void>('/forgot-password', { email });
    return response.data;
  } catch (error) {
    throw error;
  }
}

async function resetPassword(verificationCode:string, password: string): Promise<void> {
  try {
    let response = await axiosInstance.post<void>('/reset-password', { verificationCode, password });
    return response.data;
  } catch (error) {
    throw error;
  }
}

// Function to send OTP for verification
async function sendOTP(vtype: 'email' | 'mobile', value: string): Promise<{message: string}> {
  try {
    const response = await axiosInstance.post('/sendverify', { vtype, value });
    return response.data;
  } catch (error) {
    throw error;
  }
}

// Function to verify OTP
async function verifyOTP(value: string, otp: string): Promise<{message: string}> {
  try {
    const response = await axiosInstance.post('/verify', { value, otp });
    return response.data;
  } catch (error) {
    throw error;
  }
}

export {
  createUser,
  getUserById,
  getAllUsers,
  updateUser,
  updateProfile,
  deleteUser,
  checkExistingEmailOrUsername,
  forgotPassword,
  loginUser,
  resetPassword,
  getLoggedInUser,
  createUserByAdmin,
  sendOTP,
  verifyOTP,
};
